export function isMicrophoneUnavailableError(error: unknown): boolean {
  const name = error instanceof DOMException || error instanceof Error ? error.name : '';
  return name === 'NotReadableError' || name === 'NotFoundError' || name === 'OverconstrainedError';
}
